import clsx from "clsx";
import type { ForwardedRef, TextareaHTMLAttributes } from "react";
import { forwardRef } from "react";
import { errorTextID, labelID } from "../utils";
import { FieldsError } from "./Error";

interface FieldsTextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  id: string;
  labelText?: string;
  errorText?: string[];
}

function FieldsTextareaComp(
  { labelText, errorText, id, className, disabled, ...props }: FieldsTextareaProps,
  ref: ForwardedRef<HTMLTextAreaElement>
) {
  return (
    <div className={clsx("flex", "flex-col", "space-y-2")}>
      {errorText && <FieldsError id={errorTextID(id)}>{errorText}</FieldsError>}
      <label htmlFor={id} className="block">
        <span
          id={labelID(id)}
          className={clsx(
            "block",
            "font-sans",
            "font-bold",
            "text-base",
            "text-gray-700",
            "leading-none",
            "tracking-tight",
            "mb-2"
          )}
        >
          {labelText}
        </span>
        <textarea
          {...props}
          id={id}
          ref={ref}
          disabled={disabled}
          className={clsx(
            "font-sans",
            "text-[16px]",
            "text-gray-900",
            "w-full",
            "block",
            "p-2",
            "border",
            "border-gray-400",
            "rounded",
            "outline-none",
            "transition-shadow",
            "focus:ring-1",
            "focus:ring-offset-2",
            "focus:ring-gray-800",
            "disabled:cursor-not-allowed",
            "disabled:opacity-50",
            className
          )}
          aria-labelledby={labelID(id)}
          aria-describedby={errorTextID(id)}
          aria-invalid={errorText ? "true" : undefined}
        />
      </label>
    </div>
  );
}

export const FieldsTextarea = forwardRef(FieldsTextareaComp);
